import * as React from "react";
import { useMediaQuery } from 'react-responsive'
import AppMobileView from './views/AppMobileView/AppMobileView';
import AppDesktopView from './views/AppDesktopView/AppDesktopView';

function App() {
  const isMobile = useMediaQuery({ query: '(max-width: 940px)' })
  return (
    <div>
      {isMobile
        ? <AppMobileView />
        : <AppDesktopView />
      }
    </div>
  );
}

export default App;
